<template>
    <div class="rechner_template">
        <v-stepper v-model="activeStepNr">
            <v-stepper-header>
                <template v-for="step in this.steps">
                    <v-stepper-step
                            :key="'label'+step.stepNr"
                            @click.native="stepPrevTo(step.stepNr)"
                            error-icon="error"
                            :step="step.stepNr"
                            :complete="activeStepNr > step.stepNr"
                            :rules="[() => !step.$v.$error]">
                        <span class="main-text" @click="stepPrevTo(step.stepNr)">
                            <span v-html="step.label2>'' ? step.label2 : step.label"></span>
                            <!-- <small v-if="step.$v.$error"><br>Formular unvollständig</small> -->
                        </span>

                    </v-stepper-step>
                    <v-divider :key="'line'+step.stepNr"/>
                </template>
            </v-stepper-header>
            <template v-for="step in this.steps">
                <v-stepper-content :step="step.stepNr" :key="step.stepNr">
                    <v-card class="elevation-4 ma-2" height="">

                        <component :is="step.name"
                                   :activeStepNr="activeStepNr"
                                   :myStepNr="step.stepNr"
                                   :allSteps="steps"
                                   :ref="step.name"
                                   v-model="steps[step.name]"

                        >
                        </component>

                    </v-card>
                    <div style="color:#dc0000;  height: 10px;margin: -2px 0 8px 0;">
                        &nbsp;
                        <span v-if="step.$v.$error">
                            Formular unvollständig !
                        </span>
                        &nbsp;
                    </div>
                    <v-btn v-show="step.stepNr != 1"
                           color="primary"
                           @click.native="stepPrev()">
                        &lt; zurück
                    </v-btn>
                    <v-btn v-show="step.stepNr < stepsCount" :disabled="step.$v.$error"
                           color="primary"
                           @click.native="stepNext()">
                        weiter &gt;
                    </v-btn>


                </v-stepper-content>
            </template>
        </v-stepper>


        <v-dialog v-model="showDialog_submitInfo" persistent>
            <v-card class="text-xl-center">
                <v-card-text>
                    Daten werden übertragen ...
                </v-card-text>
                <v-card-text>
                    <div>
                        <v-progress-circular
                                indeterminate
                                v-bind:size="50"
                                class="primary--text"
                        />
                    </div>
                    <br>
                    <button @click.stop="rechnerState = 'submit_error'">[ - ]</button>
                    <button @click.stop="rechnerState = 'submit_success'">[ + ]</button>
                </v-card-text>
            </v-card>
        </v-dialog>


        <v-dialog v-model="showDialog_submitError" persistent>
            <v-card class="text-xl-center">
                <v-card-text>
                    Fehler bei der Übertragung ?!?
                    <br>
                    <button @click.stop="rechnerState = 'input'">[ - ]</button>
                </v-card-text>
            </v-card>
        </v-dialog>


        <v-dialog v-model="showDialog_submitDone" fullscreen transition="v-dialog-bottom-transition" :overlay=false>
            <v-card>
                <v-card-text>
                    <v-toolbar>
                        <v-btn icon="icon" @click.native="rechnerState ='input'">
                            <v-icon>close</v-icon>
                        </v-btn>
                        <v-toolbar-title>Settings</v-toolbar-title>
                        <v-btn primary light flat="flat" @click.native="rechnerState ='input'">Save</v-btn>
                    </v-toolbar>
                </v-card-text>
                <v-card-text>
                    <slot name="success-info">
                    </slot>
                </v-card-text>
            </v-card>
        </v-dialog>


    </div>
</template>
<!-- _____________________________________________________________________________________________________________________________________________________________ -->
<!-- ############################################################################################################################################################# -->
<script>
    // import SlideWrapper from '../Slide_wrapper'
    import _ from 'lodash'

    export default {
        //========================================================================================================
        name: 'RechnerTemplate',
        //========================================================================================================
        components: {},
        //========================================================================================================
        created: function () {

            for (var key in this.steps) {
                var step = this.steps[key]
                this.$options.components[step.name] = step.component
            }

        },
        //========================================================================================================
        props: ['steps', 'compo'],
        //========================================================================================================
        data: function () {
            //………………………………………………………………………………………………………………………………………………………………………………………………

            return {
                test: 1,
                activeStepNr: null,
                rechnerStates: {
                    init: 'init',
                    input: 'input',

                    offer_pending: 'offer_pending',
                    offer_error: 'offer_error',
                    offer_success: 'offer_success',

                    submit_pending: 'submit_pending',
                    submit_error: 'submit_error',
                    submit_success: 'submit_success',

                },
                rechnerState: 'input'

            }

        }, //========================================================================================================
        computed: {
            //—————————————————————————————————————————————————————————————————————————————————
            showDialog_submitInfo: function () {
                return this.rechnerState === 'submit_pending'
            }, //——————————————————————————————————————————————————————————————————————————————
            showDialog_submitError: function () {
                return this.rechnerState === 'submit_error'
            }, //——————————————————————————————————————————————————————————————————————————————

            showDialog_submitDone: function () {
                return this.rechnerState === 'submit_success'
            }, //——————————————————————————————————————————————————————————————————————————————
            stepsCount: function () {
                return Object.keys(this.steps).length
            }, //——————————————————————————————————————————————————————————————————————————————
            allStepsValid: function () {
                var state = true
                var stepName
                for (stepName in this.steps) {
                    state = state && (!this.steps[stepName].$v.invalid)
                }
                return state
            }, //——————————————————————————————————————————————————————————————————————————————

        }, //========================================================================================================
        methods: {
            //——————————————————————————————————————————————————————————————————————————————
            isStepValid: function (stepNr) {
                var step = _.find(this.steps, {'stepNr': stepNr})
                return !step.$v.$invalid
            }, //——————————————————————————————————————————————————————————————————————————————
            hasStepError: function (stepNr) {
                var step = _.find(this.steps, {'stepNr': stepNr})
                return step.$v.$error
            }, //——————————————————————————————————————————————————————————————————————————————
            getStepByNr: function (stepNr) {
                var step = _.find(this.steps, {'stepNr': stepNr})
                return step
            }, //——————————————————————————————————————————————————————————————————————————————
            stepNext: function () {
                var nextStep = (this.activeStepNr < this.stepsCount) ? (this.activeStepNr + 1) : (this.activeStepNr)
                this.stepTo(nextStep, true)
            }, //——————————————————————————————————————————————————————————————————————————————
            stepPrev: function () {
                var prevStep = (this.activeStepNr > 1) ? (this.activeStepNr - 1) : (this.activeStepNr)
                this.stepTo(prevStep, false)
            }, //——————————————————————————————————————————————————————————————————————————————
            stepPrevTo: function (targetStep) {
                if (targetStep < this.activeStepNr) {
                    this.stepTo(targetStep, false)
                }
            }, //——————————————————————————————————————————————————————————————————————————————
            stepTo: function (targetStep, onlyIfValid) {

                var step = this.getStepByNr(this.activeStepNr)
                console.log('onlyIfValid:', onlyIfValid)
                console.log('targetStep:', targetStep)
                console.log('activeStep:', step)
                console.log('validator:', step.$v)
                if (onlyIfValid) {
                    step.$v.$touch()
                    if (!step.$v.$invalid) {
                        window.scrollTo(0, 0)
                        this.activeStepNr = targetStep
                    }
                } else {
                    window.scrollTo(0, 0)
                    this.activeStepNr = targetStep
                }

            }, //——————————————————————————————————————————————————————————————————————————————

        }, //========================================================================================================
    }

    /*
     ¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯
     ¨¨¨¨¨¨¨¨¨¨¨¨¨¨¨¨¨¨¨¨¨¨¨¨¨¨
     ………………………………………………………………………
     •••••••••••••••••••••••••••
     »»»»»»»»»»»»»»»»»»»»»»»»»»
     ­­­­­­­­­­­­­­­­­­­­­­­­­­
     ———————————————————————————

     –––––––––––––––––––––
     */
</script>
<!-- ############################################################################################################################################################# -->
<!-- ¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯¯ -->
<style type="less">

    .stepper__step.stepper__step--complete {
        cursor: pointer
    }

    .stepper__step.stepper__step--inactive {
        cursor: default;
    }

    .section_header {
        margin: 0 -20px 12px 0;

    }

    .section_header h6 {
        font-size: 1.4em;
        font-weight: normal;
        margin: 0 0 0 0;
    }

    h6 {
        margin: 5px 0 3px 0;
    }

    .stepper__content {
        padding: 0;
    }

    .stepper {
        box-shadow: none;
    }

    .stepper__header {
        box-shadow: none;
        margin: 10px 0 0 0;
        min-height: 42px;
    }

    .stepper__step {
        padding: 0px 20px 0px 20px;
    }


    /* =============================================================*/
    .v-input__slot {
        margin-bottom: 1px !important;
        margin-top: 10px !important;
    }

    div.my-form-container .v-text-field input{
        padding: 5px 0 0 0;
    }

    .v-select__slot{
        margin-bottom: -3px !important;
        margin-top: 0px !important;
    }

    .v-select__selection{
        margin-bottom: 4px !important;
        margin-top: 3px !important;
    }
    div.rechner_template label.error--text {
        color: #af0011 !important;
    }

    div.my-form-container .layout.row {
        /*
        background-color: #eeeeee;
        border-bottom:red solid 4px;
        */

    }

    div.my-form-container .layout.row:nth-child(odd) {
      //  background-color: #eeeeee;
     //   border-bottom: red solid 4px;
    }


    .radio-list2 {
        align-items: center;
        margin: 0px 10px 0px 0px;
        line-height: 1.1em
    }

    .v-messages__wrapper {
        margin-bottom: 1px;
    }

    .error--text .v-input__control{
        background-color: #fdecec;
    }
    /* =============================================================*/
    /*
      .stepper__label span.main-text {
          padding-left: 35px;
          margin-left: -35px;
          cursor: pointer;
          z-index: 1;

      }

      .rechner {

      }

      .rechner-content {
          position: relative;
          width: 100%;
          height: 300px;
          border: 2px solid red;
          overflow: hidden;
      }

      .step {
          width: 100%;
          height: 50%;
          position: absolute;
          left: 0;
          top: 0;
          background: #eeeeee;
          border: solid 3px purple;
      }

      .rechner-footer {
          border: 2px solid blue;

      }

      .fadeIn-enter-active {
          transition: all 1s ease-in;
          opacity: 1;
      }

      .fadeIn-enter

      {

          opacity: 0;
      }

      */
</style>
